<form [formGroup]="group">
    <div class="grid">
        <div class="col-12 md:col-6 lg:col-2">
            <p-floatLabel class="w-full" variant="on">
                <p-select [options]="listTipoTarifa" styleClass="w-full" formControlName="tipo" size="small"
                    [ngClass]="{ 'input-error': group.get('tipo')?.invalid && group.get('tipo')?.touched }"></p-select>
                <label for="tipo">Tipos de servicio</label>
            </p-floatLabel>
            <small *ngIf="group.get('tipo')?.invalid && group.get('tipo')?.touched" style="color: red;">Seleccione un
                tipo
                de
                tarifa.</small>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
            <p-floatLabel class="w-full" variant="on">
                <p-select [options]="listEstados" styleClass="w-full" formControlName="estado" size="small"></p-select>
                <label for="tipo">Estado</label>
            </p-floatLabel>
        </div>

        <div class="col-12 md:col-6 lg:col-2">

            <p-checkbox formControlName="pprofit" binary="true"></p-checkbox>
            <label for="size_normal">Pendiente de profit</label>

        </div>


        <p-button icon="pi pi-search" label="Buscar" (onClick)="search()" variant="outlined" size="small"
            class="col-12 md:col-3 lg:col-1" styleClass="w-full"></p-button>
        <div class="col-12 md:col-3 lg:col-2">
            <div class="h-full flex align-items-center justify-content-center text-xs">
                [ COMPRA: {{tipoCambio.compra}} - VENTA: {{tipoCambio.venta}} ]
            </div>

        </div>
    </div>
</form>

<!-- <input type="file" #fileInput style="display: none" (change)="handleFileInput($event)" accept=".xlsx, .xls" /> -->

<app-a-treetable [dataTable]="datatablaTarifa" [metadataTable]="metadatatable" editMode="row" editChildrenMode="cell"
    [saveChangesFunction]="operationByStatusTable.bind(this)" [funcionalButtonsFather]="rowFatherFunctions"
    [deleteRowChildren]="true" editChildrenMode="cell" editModeChildren="cell" editModeFather="row"
    [addRowFather]="true" [addRowChildren]="true" [funcionalButtonsChildren]="rowChildrenFunctions"
    [optionTable]="optionTable" [listaSelectByType]="listaFiltrada" [functionOnInit]="functionOnInitTable.bind(this)"
    [showFilters]="true"></app-a-treetable>
<!--  [buttonCaption]="addButtons"  -->

<div class="a-footer"></div>

<p-dialog header="DETALLE" [modal]="true" [(visible)]="visible" [style]="{ width: '25rem' }" [closable]="true">
    <ul>
        <li *ngFor="let item of detallePopUp">
            <span class="text-sm font-medium">{{ item.descripcion }}</span>
            <ul>
                <li *ngFor="let i of item.detalle">
                    <span class="text-sm">{{ i.descripcion }}</span>
                </li>
            </ul>
        </li>
    </ul>
</p-dialog>




<p-dialog *ngIf="popUpAuditoriaChangeControl" [(visible)]="popUpAuditoriaChangeControl"
    header="Resultado de la Auditoría - Tarifario" appendTo="body">
    <div class="a-w1-column" style="max-width: 1400px; overflow-x: auto;">
        <div class="a-w1-row">
            <app-datatable [dataTable]="dt_auditoriaServChangeControl" [metadataTable]="mt_auditoriaServChangeControl">
            </app-datatable>
        </div>
        <div class="a-w1-row">
            <p-button label="Salir" (onClick)="aceptarPopUpDocumento()"></p-button>

        </div>
    </div>
</p-dialog>


<p-dialog *ngIf="popUpProfitMasivo" [(visible)]="popUpProfitMasivo" header="Asignacion de profit" appendTo="body">
    <div class="a-example-full-width-alterno-content-column" [style]="{width: '25vw', height: '13vh'}">

        <form [formGroup]="groupprofit">

            <div class="a-w1 a-w1-row mt-2">
                <div class="a-w2">
                    <p-floatLabel class="w-full" variant="on" appendTo="body">
                        <input pInputText formControlName="profit" class="w-full" size="small" appendTo="body" />
                        <label for="tipo">Profit</label>
                    </p-floatLabel>
                    <small *ngIf="group.get('tipo')?.invalid && group.get('tipo')?.touched"
                        style="color: red;">Seleccione
                        un
                        tipo
                        de
                        tarifa.</small>
                </div>

                <div class="a-w2">

                    <p-floatLabel class="w-full" variant="on" appendTo="body">
                        <p-select [options]="listMoneda" class="w-full" formControlName="tipoprofitmoneda"
                            appendTo="body" size="small"></p-select>
                        <label for="tipo">Moneda</label>
                    </p-floatLabel>

                </div>
            </div>

            <div class="flex justify-content-center gap-3 mt-3">
                <p-button label="Asignar" (onClick)="asignarprofitmasivo()"></p-button>
                <p-button label="Salir" (onClick)="SalirProfit()"></p-button>
            </div>

        </form>
    </div>
</p-dialog>




<p-dialog *ngIf="popupObservaciones" [(visible)]="popupObservaciones" header="Observaciones" appendTo="body">
    <div class="a-w1-column" style="max-width: 700px; overflow-x: auto;">
        <div class="a-w1-row">
            <form [formGroup]="groupadicionales">

                <textarea pInputTextarea required formControlName="observaciones"
                    [style]="{width: '650px', height: '250px'}" (ngModelChange)="handleInputChange()" pAutoResize
                    rows="3" pSize="small">
                                        </textarea>

            </form>
        </div>
        <div class="a-w1-row">
            <p-button label="Aceptar" (onClick)="procesarobservaciones()"></p-button>
            <p-button label="Salir" (onClick)="viewobservacionsalir()"></p-button>
        </div>

        <div class="a-w1-row">


        </div>
    </div>
</p-dialog>